module.exports = __webpack_public_path__ + "img/branding.5a5bec87.png";